const boardOptions = [
  {
    label: '743',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '7s4h3c',
    ],
  },
  {
    label: 'KQ8',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'KsQh8h-L',
      'KhQh8s-H',
    ],
  },
  {
    label: 'J75',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Jh7h5s-H',
      'Js7h5h-L',
    ],
  },
  {
    label: 'AQ6',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'AsQh6c',
    ],
  },
  {
    label: 'AA3',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'AsAh3h',
    ],
  },
  {
    label: 'JJT',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'JsJhTh',
    ],
  },
  {
    label: 'AA8',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'AsAh8c',
    ],
  },
  {
    label: 'TT7',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'TsTh7c',
    ],
  },
  {
    label: 'JT7',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'JsTh7h',
    ],
  },
  {
    label: 'J82',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Js8h2h-L',
      'Jh8h2s-H',
    ],
  },
  {
    label: 'KT3',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'KhTh3s-H',
      'KsTh3h-L',
    ],
  },
  {
    label: 'Q76',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Qs7h6h-L',
      'Qh7h6s-H',
    ],
  },
  {
    label: 'Q74',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Qh7h4s-H',
      'Qs7h4h-L',
    ],
  },
  {
    label: 'A96',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'As9h6c',
    ],
  },
  {
    label: 'AJJ',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'AsJhJc',
    ],
  },
  {
    label: 'KQ9',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'KsQh9h',
    ],
  },
  {
    label: 'KT9',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'KsTh9h',
    ],
  },
  {
    label: 'K73',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ks7h3c',
    ],
  },
  {
    label: 'KQJ',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'KsQhJh',
    ],
  },
  {
    label: 'Q98',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'Qs9h8h',
    ],
  },
  {
    label: '965',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '9s6h5c',
    ],
  },
  {
    label: 'AT7',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'AsTh7h-L',
      'AhTs7h-H',
    ],
  },
  {
    label: 'JT6',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'JhTh6s-H',
      'JsTh6h-L',
    ],
  },
  {
    label: '862',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'unpaired',
    varieties: [
      '8s6s2s',
    ],
  },
  {
    label: 'JJ6',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'JsJh6h',
    ],
  },
  {
    label: '855',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '8s5h5c',
    ],
  },
  {
    label: '987',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '9s8h7h',
    ],
  },
  {
    label: 'J87',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'Js8h7c',
    ],
  },
  {
    label: '875',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '8s7h5c',
    ],
  },
  {
    label: 'A65',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'As6h5h-L',
      'Ah6s5h-H',
    ],
  },
  {
    label: 'K98',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Ks9h8h-L',
      'Kh9h8s-H',
    ],
  },
  {
    label: 'K32',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Kh3h2s-H',
      'Ks3h2h-L',
    ],
  },
  {
    label: 'QJ7',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'QsJh7h-L',
      'QhJh7s-H',
    ],
  },
  {
    label: 'Q99',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'Qh9h9s',
    ],
  },
  {
    label: '864',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '8s6h4c',
    ],
  },
  {
    label: '994',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '9s9h4h',
    ],
  },
  {
    label: 'AKK',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'AsKhKc',
    ],
  },
  {
    label: 'QQQ',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'QsQhQc',
    ],
  },
  {
    label: 'J43',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Js4h3h-L',
      'Jh4h3s-H',
    ],
  },
  {
    label: 'AJ7',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'AsJh7c',
    ],
  },
  {
    label: 'KJ9',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'straight',
    varieties: [
      'KsJs9s',
    ],
  },
  {
    label: 'T96',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'Ts9h6h',
    ],
  },
  {
    label: 'JT4',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'JsTh4h-L',
      'JhTh4s-H',
    ],
  },
  {
    label: '655',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '6s5h5c',
    ],
  },
  {
    label: 'AT2',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'AsTh2h-L',
      'AhTs2h-H',
    ],
  },
  {
    label: 'T62',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ts6h2c',
    ],
  },
  {
    label: 'T54',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ts5h4c',
    ],
  },
  {
    label: 'J97',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'Js9h7h',
    ],
  },
  {
    label: 'JT8',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'JsTh8c',
    ],
  },
  {
    label: 'AQ6',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'AsQh6h-L',
      'AhQs6h-H',
    ],
  },
  {
    label: '982',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      '9s8h2h',
    ],
  },
  {
    label: '762',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      '7s6h2c',
    ],
  },
  {
    label: 'JT8',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'JsTh8h',
    ],
  },
  {
    label: '986',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '9s8h6c',
    ],
  },
  {
    label: 'J93',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Js9h3h-L',
      'Jh9h3s-H',
    ],
  },
  {
    label: 'AT9',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'AhTs9h-H',
      'AsTh9h-L',
    ],
  },
  {
    label: '843',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      '8s4h3h',
    ],
  },
  {
    label: 'AJ9',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'AsJh9c',
    ],
  },
  {
    label: 'KJ7',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'KsJh7c',
    ],
  },
  {
    label: 'Q66',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'Qs6h6c',
    ],
  },
  {
    label: 'AKQ',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'AsKhQh-L',
      'AhKsQh-H',
    ],
  },
  {
    label: 'A82',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'As8h2c',
    ],
  },
  {
    label: 'J53',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Js5h3c',
    ],
  },
  {
    label: 'T75',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'unpaired',
    varieties: [
      'Ts7s5s',
    ],
  },
  {
    label: '763',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '7s6h3c',
    ],
  },
  {
    label: 'K95',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Kh9h5s-H',
      'Ks9h5h-L',
    ],
  },
  {
    label: 'A54',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'As5h4h-L',
      'Ah5s4h-H',
    ],
  },
  {
    label: 'QT9',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'QsTh9h',
    ],
  },
  {
    label: 'AKJ',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'AsKhJc',
    ],
  },
  {
    label: '932',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      '9s3h2h',
    ],
  },
  {
    label: '762',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      '7s6h2h',
    ],
  },
  {
    label: '964',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      '9s6h4c',
    ],
  },
  {
    label: '998',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '9s9h8h',
    ],
  },
  {
    label: 'AQ9',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'AhQs9h-H',
      'AsQh9h-L',
    ],
  },
  {
    label: 'K95',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ks9h5c',
    ],
  },
  {
    label: 'T92',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ts9h2c',
    ],
  },
  {
    label: 'KQ8',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'unpaired',
    varieties: [
      'KsQs8s',
    ],
  },
  {
    label: '982',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'unpaired',
    varieties: [
      '9s8s2s',
    ],
  },
  {
    label: '555',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '5s5h5c',
    ],
  },
  {
    label: '976',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '9s7h6h',
    ],
  },
  {
    label: 'A32',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'As3h2c',
    ],
  },
  {
    label: 'KJ7',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'KhJh7s-H',
      'KsJh7h-L',
    ],
  },
  {
    label: 'KQ4',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'KsQh4c',
    ],
  },
  {
    label: '873',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      '8s7h3c',
    ],
  },
  {
    label: 'Q76',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'unpaired',
    varieties: [
      'Qs7s6s',
    ],
  },
  {
    label: 'QQ2',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'QsQh2h',
    ],
  },
  {
    label: '655',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '6h5h5s',
    ],
  },
  {
    label: '876',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '8s7h6c',
    ],
  },
  {
    label: 'T92',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Ts9h2h-L',
      'Th9h2s-H',
    ],
  },
  {
    label: 'K82',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ks8h2c',
    ],
  },
  {
    label: '755',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '7h5h5s',
    ],
  },
  {
    label: 'AJT',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'AhJsTh-H',
      'AsJhTh-L',
    ],
  },
  {
    label: '864',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '8s6h4h',
    ],
  },
  {
    label: 'KJ8',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'KsJh8h-L',
      'KhJh8s-H',
    ],
  },
  {
    label: 'K87',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Ks8h7h-L',
      'Kh8h7s-H',
    ],
  },
  {
    label: '932',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      '9s3h2c',
    ],
  },
  {
    label: 'A77',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'Ah7h7s',
    ],
  },
  {
    label: 'KJT',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'KsJhTh',
    ],
  },
  {
    label: 'KJ9',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'KsJh9h',
    ],
  },
  {
    label: 'QJT',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'QsJhTh',
    ],
  },
  {
    label: 'KJT',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'KsJhTc',
    ],
  },
  {
    label: 'K82',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Kh8h2s-H',
      'Ks8h2h-L',
    ],
  },
  {
    label: '742',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      '7s4h2h',
    ],
  },
  {
    label: 'Q43',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Qs4h3c',
    ],
  },
  {
    label: 'J93',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Js9h3c',
    ],
  },
  {
    label: 'J86',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Js8h6c',
    ],
  },
  {
    label: 'A53',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'straight',
    varieties: [
      'As5s3s',
    ],
  },
  {
    label: 'AJJ',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'AhJhJs',
    ],
  },
  {
    label: '654',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '6s5h4c',
    ],
  },
  {
    label: 'J55',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'Jh5h5s',
    ],
  },
  {
    label: 'KQQ',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'KsQhQc',
    ],
  },
  {
    label: '755',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '7s5h5c',
    ],
  },
  {
    label: 'A54',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'As5h4c',
    ],
  },
  {
    label: 'T87',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'Ts8h7c',
    ],
  },
  {
    label: '542',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '5s4h2c',
    ],
  },
  {
    label: 'QT5',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'QhTh5s-H',
      'QsTh5h-L',
    ],
  },
  {
    label: 'Q64',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Qs6h4c',
    ],
  },
  {
    label: 'JT4',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'JsTh4c',
    ],
  },
  {
    label: 'J97',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'Js9h7c',
    ],
  },
  {
    label: 'A96',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Ah9s6h-H',
      'As9h6h-L',
    ],
  },
  {
    label: 'AK9',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'AsKh9c',
    ],
  },
  {
    label: 'A75',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'As7h5c',
    ],
  },
  {
    label: 'K63',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ks6h3c',
    ],
  },
  {
    label: 'K53',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ks5h3c',
    ],
  },
  {
    label: 'J62',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Js6h2c',
    ],
  },
  {
    label: 'AAQ',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'AsAhQc',
    ],
  },
  {
    label: 'AA3',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'AsAh3c',
    ],
  },
  {
    label: '742',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      '7s4h2c',
    ],
  },
  {
    label: 'A44',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'As4h4c',
    ],
  },
  {
    label: 'KKT',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'KsKhTc',
    ],
  },
  {
    label: 'K44',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'Ks4h4c',
    ],
  },
  {
    label: 'J98',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'Js9h8h',
    ],
  },
  {
    label: 'KJ9',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'KsJh9c',
    ],
  },
  {
    label: 'JT9',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'JsTh9c',
    ],
  },
  {
    label: '865',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '8s6h5c',
    ],
  },
  {
    label: 'A82',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Ah8s2h-H',
      'As8h2h-L',
    ],
  },
  {
    label: 'QT5',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'QsTh5c',
    ],
  },
  {
    label: 'J98',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'Js9h8c',
    ],
  },
  {
    label: 'K73',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Kh7h3s-H',
      'Ks7h3h-L',
    ],
  },
  {
    label: 'Q84',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Qh8h4s-H',
      'Qs8h4h-L',
    ],
  },
  {
    label: 'Q87',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Qs8h7c',
    ],
  },
  {
    label: 'K65',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Ks6h5h-L',
      'Kh6h5s-H',
    ],
  },
  {
    label: 'QT7',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'QsTh7h-L',
      'QhTh7s-H',
    ],
  },
  {
    label: 'Q92',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Qs9h2h-L',
      'Qh9h2s-H',
    ],
  },
  {
    label: 'J62',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Js6h2h-L',
      'Jh6h2s-H',
    ],
  },
  {
    label: 'T75',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ts7h5c',
    ],
  },
  {
    label: 'AQT',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'straight',
    varieties: [
      'AsQsTs',
    ],
  },
  {
    label: '877',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '8h7h7s',
    ],
  },
  {
    label: '664',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '6s6h4c',
    ],
  },
  {
    label: 'K53',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Ks5h3h-L',
      'Kh5h3s-H',
    ],
  },
  {
    label: 'A63',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'As6h3c',
    ],
  },
  {
    label: '732',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      '7s3h2c',
    ],
  },
  {
    label: 'T76',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'Ts7h6h',
    ],
  },
  {
    label: '653',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '6s5h3c',
    ],
  },
  {
    label: 'AK5',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'AsKh5h-L',
      'AhKs5h-H',
    ],
  },
  {
    label: 'K32',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ks3h2c',
    ],
  },
  {
    label: '986',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '9s8h6h',
    ],
  },
  {
    label: 'AKQ',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'AsKhQc',
    ],
  },
  {
    label: 'A65',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'As6h5c',
    ],
  },
  {
    label: 'K98',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ks9h8c',
    ],
  },
  {
    label: 'AA8',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'AsAh8h',
    ],
  },
  {
    label: '776',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '7s7h6h',
    ],
  },
  {
    label: '622',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '6h2h2s',
    ],
  },
  {
    label: 'KJ6',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'KsJh6c',
    ],
  },
  {
    label: '954',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      '9s5h4c',
    ],
  },
  {
    label: '882',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '8s8h2h',
    ],
  },
  {
    label: '433',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '4h3h3s',
    ],
  },
  {
    label: '733',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '7s3h3c',
    ],
  },
  {
    label: '754',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '7s5h4h',
    ],
  },
  {
    label: 'T62',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Ts6h2h-L',
      'Th6h2s-H',
    ],
  },
  {
    label: 'J55',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'Js5h5c',
    ],
  },
  {
    label: '622',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '6s2h2c',
    ],
  },
  {
    label: 'QT8',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'QsTh8h',
    ],
  },
  {
    label: 'T87',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'Ts8h7h',
    ],
  },
  {
    label: '985',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '9s8h5c',
    ],
  },
  {
    label: 'AK9',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'AsKh9h-L',
      'AhKs9h-H',
    ],
  },
  {
    label: '964',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      '9s6h4h',
    ],
  },
  {
    label: 'JT6',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'JsTh6c',
    ],
  },
  {
    label: 'Q73',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'unpaired',
    varieties: [
      'Qs7s3s',
    ],
  },
  {
    label: 'KQQ',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'KhQhQs',
    ],
  },
  {
    label: 'K77',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'Kh7h7s',
    ],
  },
  {
    label: 'KT6',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'KsTh6c',
    ],
  },
  {
    label: 'JT7',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'JsTh7c',
    ],
  },
  {
    label: 'Q64',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Qh6h4s-H',
      'Qs6h4h-L',
    ],
  },
  {
    label: '876',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '8s7h6h',
    ],
  },
  {
    label: 'Q84',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Qs8h4c',
    ],
  },
  {
    label: 'QT5',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'unpaired',
    varieties: [
      'QsTs5s',
    ],
  },
  {
    label: 'KKT',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'KsKhTh',
    ],
  },
  {
    label: 'Q73',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Qs7h3c',
    ],
  },
  {
    label: 'T98',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'Ts9h8h',
    ],
  },
  {
    label: 'KJ6',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'KsJh6h-L',
      'KhJh6s-H',
    ],
  },
  {
    label: 'J96',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Jh9h6s-H',
      'Js9h6h-L',
    ],
  },
  {
    label: 'J82',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Js8h2c',
    ],
  },
  {
    label: 'K44',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'Kh4h4s',
    ],
  },
  {
    label: '884',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '8s8h4h',
    ],
  },
  {
    label: '553',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '5s5h3h',
    ],
  },
  {
    label: '966',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '9s6h6c',
    ],
  },
  {
    label: '776',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '7s7h6c',
    ],
  },
  {
    label: 'AT6',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'AhTs6h-H',
      'AsTh6h-L',
    ],
  },
  {
    label: 'QJ2',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'QhJh2s-H',
      'QsJh2h-L',
    ],
  },
  {
    label: 'Q86',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Qs8h6h-L',
      'Qh8h6s-H',
    ],
  },
  {
    label: '976',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '9s7h6c',
    ],
  },
  {
    label: 'AQ9',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'AsQh9c',
    ],
  },
  {
    label: 'KQ8',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'KsQh8c',
    ],
  },
  {
    label: 'T95',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ts9h5c',
    ],
  },
  {
    label: 'QJT',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'QsJhTc',
    ],
  },
  {
    label: 'Q98',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'Qs9h8c',
    ],
  },
  {
    label: 'KT6',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'KsTh6h-L',
      'KhTh6s-H',
    ],
  },
  {
    label: 'J53',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Jh5h3s-H',
      'Js5h3h-L',
    ],
  },
  {
    label: '862',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      '8s6h2h',
    ],
  },
  {
    label: 'KJ8',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'KsJh8c',
    ],
  },
  {
    label: 'K65',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ks6h5c',
    ],
  },
  {
    label: 'Q86',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Qs8h6c',
    ],
  },
  {
    label: '664',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '6s6h4h',
    ],
  },
  {
    label: '442',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '4s4h2c',
    ],
  },
  {
    label: 'A63',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Ah6s3h-H',
      'As6h3h-L',
    ],
  },
  {
    label: '966',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '9h6h6s',
    ],
  },
  {
    label: 'A77',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'As7h7c',
    ],
  },
  {
    label: 'KK6',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'KsKh6c',
    ],
  },
  {
    label: 'QQ8',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'QsQh8c',
    ],
  },
  {
    label: 'T55',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'Ts5h5c',
    ],
  },
  {
    label: '882',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '8s8h2c',
    ],
  },
  {
    label: '772',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '7s7h2c',
    ],
  },
  {
    label: 'AT9',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'AsTh9c',
    ],
  },
  {
    label: 'Q74',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Qs7h4c',
    ],
  },
  {
    label: 'TT4',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'TsTh4h',
    ],
  },
  {
    label: '833',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '8h3h3s',
    ],
  },
  {
    label: 'JJT',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'JsJhTc',
    ],
  },
  {
    label: 'J88',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'Js8h8c',
    ],
  },
  {
    label: '433',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '4s3h3c',
    ],
  },
  {
    label: '542',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '5s4h2h',
    ],
  },
  {
    label: 'QT7',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'QsTh7c',
    ],
  },
  {
    label: 'JT9',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'JsTh9h',
    ],
  },
  {
    label: '865',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '8s6h5h',
    ],
  },
  {
    label: 'T76',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'Ts7h6c',
    ],
  },
  {
    label: '532',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '5s3h2c',
    ],
  },
  {
    label: '954',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      '9s5h4h',
    ],
  },
  {
    label: 'KT8',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'KsTh8c',
    ],
  },
  {
    label: 'T52',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ts5h2c',
    ],
  },
  {
    label: 'KK6',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'KsKh6h',
    ],
  },
  {
    label: 'KT9',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'KsTh9c',
    ],
  },
  {
    label: '432',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '4s3h2c',
    ],
  },
  {
    label: 'A73',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Ah7s3h-H',
      'As7h3h-L',
    ],
  },
  {
    label: 'KQ4',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'KhQh4s-H',
      'KsQh4h-L',
    ],
  },
  {
    label: 'AK5',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'AsKh5c',
    ],
  },
  {
    label: '973',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      '9s7h3c',
    ],
  },
  {
    label: '843',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      '8s4h3c',
    ],
  },
  {
    label: 'QJ9',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'QsJh9h',
    ],
  },
  {
    label: 'AJ9',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'AhJs9h-H',
      'AsJh9h-L',
    ],
  },
  {
    label: 'K75',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Ks7h5h-L',
      'Kh7h5s-H',
    ],
  },
  {
    label: 'J86',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Jh8h6s-H',
      'Js8h6h-L',
    ],
  },
  {
    label: 'T84',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Th8h4s-H',
      'Ts8h4h-L',
    ],
  },
  {
    label: 'Q92',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Qs9h2c',
    ],
  },
  {
    label: 'T55',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'Th5h5s',
    ],
  },
  {
    label: 'Q22',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'Qs2h2c',
    ],
  },
  {
    label: '965',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '9s6h5h',
    ],
  },
  {
    label: 'A87',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'As8h7h-L',
      'Ah8s7h-H',
    ],
  },
  {
    label: 'K95',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'unpaired',
    varieties: [
      'Ks9s5s',
    ],
  },
  {
    label: '743',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '7s4h3h',
    ],
  },
  {
    label: '654',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '6s5h4h',
    ],
  },
  {
    label: '532',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '5s3h2h',
    ],
  },
  {
    label: 'KQ9',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'KsQh9c',
    ],
  },
  {
    label: 'QJ9',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'QsJh9c',
    ],
  },
  {
    label: 'AJ3',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'AsJh3c',
    ],
  },
  {
    label: 'A32',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'Ah3s2h-H',
      'As3h2h-L',
    ],
  },
  {
    label: 'AQT',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'AsQhTc',
    ],
  },
  {
    label: 'T52',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Ts5h2h-L',
      'Th5h2s-H',
    ],
  },
  {
    label: 'AT2',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'AsTh2c',
    ],
  },
  {
    label: '772',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '7s7h2h',
    ],
  },
  {
    label: '998',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '9s9h8c',
    ],
  },
  {
    label: '875',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '8s7h5h',
    ],
  },
  {
    label: 'AJ7',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'AhJs7h-H',
      'AsJh7h-L',
    ],
  },
  {
    label: 'AJ3',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'AsJh3h-L',
      'AhJs3h-H',
    ],
  },
  {
    label: '982',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      '9s8h2c',
    ],
  },
  {
    label: 'TT4',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'TsTh4c',
    ],
  },
  {
    label: 'AQT',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'AsQhTh-L',
      'AhQsTh-H',
    ],
  },
  {
    label: '987',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '9s8h7c',
    ],
  },
  {
    label: '754',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '7s5h4c',
    ],
  },
  {
    label: 'K63',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Kh6h3s-H',
      'Ks6h3h-L',
    ],
  },
  {
    label: 'Q73',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Qs7h3h-L',
      'Qh7h3s-H',
    ],
  },
  {
    label: 'A84',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'unpaired',
    varieties: [
      'As8s4s',
    ],
  },
  {
    label: 'J53',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'unpaired',
    varieties: [
      'Js5s3s',
    ],
  },
  {
    label: '643',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      '6s4h3c',
    ],
  },
  {
    label: '873',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      '8s7h3h',
    ],
  },
  {
    label: 'QJ7',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'QsJh7c',
    ],
  },
  {
    label: 'T73',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ts7h3c',
    ],
  },
  {
    label: 'AQ9',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'unpaired',
    varieties: [
      'AsQs9s',
    ],
  },
  {
    label: 'TT7',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'TsTh7h',
    ],
  },
  {
    label: 'K77',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'Ks7h7c',
    ],
  },
  {
    label: 'T75',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Ts7h5h-L',
      'Th7h5s-H',
    ],
  },
  {
    label: '973',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      '9s7h3h',
    ],
  },
  {
    label: '732',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      '7s3h2h',
    ],
  },
  {
    label: 'Q76',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Qs7h6c',
    ],
  },
  {
    label: 'T84',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ts8h4c',
    ],
  },
  {
    label: '432',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '4s3h2h',
    ],
  },
  {
    label: 'Q66',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'Qh6h6s',
    ],
  },
  {
    label: '733',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '7h3h3s',
    ],
  },
  {
    label: 'Q99',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'Qs9h9c',
    ],
  },
  {
    label: 'AKJ',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'AhKsJh-H',
      'AsKhJh-L',
    ],
  },
  {
    label: 'KQJ',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'KsQhJc',
    ],
  },
  {
    label: 'A75',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'As7h5h-L',
      'Ah7s5h-H',
    ],
  },
  {
    label: 'KT8',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'KhTh8s-H',
      'KsTh8h-L',
    ],
  },
  {
    label: 'K75',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ks7h5c',
    ],
  },
  {
    label: '542',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'straight',
    varieties: [
      '5s4s2s',
    ],
  },
  {
    label: 'J88',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'Jh8h8s',
    ],
  },
  {
    label: 'T95',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Th9h5s-H',
      'Ts9h5h-L',
    ],
  },
  {
    label: 'AT7',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'AsTh7c',
    ],
  },
  {
    label: 'A73',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'As7h3c',
    ],
  },
  {
    label: 'QJ2',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'QsJh2c',
    ],
  },
  {
    label: 'J43',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Js4h3c',
    ],
  },
  {
    label: 'A44',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'Ah4h4s',
    ],
  },
  {
    label: 'JJ6',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'JsJh6c',
    ],
  },
  {
    label: '877',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '8s7h7c',
    ],
  },
  {
    label: 'AT6',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'AsTh6c',
    ],
  },
  {
    label: 'KT3',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'KsTh3c',
    ],
  },
  {
    label: '862',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      '8s6h2c',
    ],
  },
  {
    label: 'AT9',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'unpaired',
    varieties: [
      'AsTs9s',
    ],
  },
  {
    label: 'T88',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'Th8h8s',
    ],
  },
  {
    label: '994',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '9s9h4c',
    ],
  },
  {
    label: '763',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '7s6h3h',
    ],
  },
  {
    label: 'Q43',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Qs4h3h-L',
      'Qh4h3s-H',
    ],
  },
  {
    label: 'JT4',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'unpaired',
    varieties: [
      'JsTs4s',
    ],
  },
  {
    label: '442',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '4s4h2h',
    ],
  },
  {
    label: 'J96',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Js9h6c',
    ],
  },
  {
    label: 'AAQ',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'AsAhQh',
    ],
  },
  {
    label: 'J87',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      'Js8h7h',
    ],
  },
  {
    label: 'QT9',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'QsTh9c',
    ],
  },
  {
    label: 'QT8',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'QsTh8c',
    ],
  },
  {
    label: 'T98',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'Ts9h8c',
    ],
  },
  {
    label: 'Q87',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Qh8h7s-H',
      'Qs8h7h-L',
    ],
  },
  {
    label: 'K87',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Ks8h7c',
    ],
  },
  {
    label: 'AKK',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'AhKhKs',
    ],
  },
  {
    label: 'QQ8',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'QsQh8h',
    ],
  },
  {
    label: 'QQ2',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'QsQh2c',
    ],
  },
  {
    label: '833',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '8s3h3c',
    ],
  },
  {
    label: 'T54',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Th5h4s-H',
      'Ts5h4h-L',
    ],
  },
  {
    label: 'JT8',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'straight',
    varieties: [
      'JsTs8s',
    ],
  },
  {
    label: '742',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'unpaired',
    varieties: [
      '7s4s2s',
    ],
  },
  {
    label: '855',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      '8h5h5s',
    ],
  },
  {
    label: '643',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '6s4h3h',
    ],
  },
  {
    label: 'AJT',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'AsJhTc',
    ],
  },
  {
    label: 'J75',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'Js7h5c',
    ],
  },
  {
    label: '986',
    hasHighLow: false,
    boardSuit: 'mono',
    boardType: 'straight',
    varieties: [
      '9s8s6s',
    ],
  },
  {
    label: '884',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '8s8h4c',
    ],
  },
  {
    label: '553',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      '5s5h3c',
    ],
  },
  {
    label: '985',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'straight',
    varieties: [
      '9s8h5h',
    ],
  },
  {
    label: 'T96',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'straight',
    varieties: [
      'Ts9h6c',
    ],
  },
  {
    label: 'A87',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'unpaired',
    varieties: [
      'As8h7c',
    ],
  },
  {
    label: 'Q22',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'Qh2h2s',
    ],
  },
  {
    label: 'QTT',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'QsThTc',
    ],
  },
  {
    label: 'T88',
    hasHighLow: false,
    boardSuit: 'rainbow',
    boardType: 'paired',
    varieties: [
      'Ts8h8c',
    ],
  },
  {
    label: 'T73',
    hasHighLow: true,
    boardSuit: 'two-tone',
    boardType: 'unpaired',
    varieties: [
      'Th7h3s-H',
      'Ts7h3h-L',
    ],
  },
  {
    label: 'QTT',
    hasHighLow: false,
    boardSuit: 'two-tone',
    boardType: 'paired',
    varieties: [
      'QhThTs',
    ],
  },
];

export default boardOptions;
